export const enviroment = {
    PRODUCTION: false,
    MOCKUP: false,
    BASE_URL_API: 'https://dev-api.ftpilot.com',
    BASE_URL_FILES: 'https://dev-api.ftpilot.com',
    BASE_URL: 'https://dev.ftpilot.com',
    BASE_URL_API_IMAGE_VCU: 'https://dev.ftpilot.com/ft_models',
    BASE_URL_CDN_MEDIA: 'https://dev-cdn-media.ftpilot.com/',
    BASE_URL_SSE: 'https://sse-dev.ftpilot.com',
    COGNITO_OAUTH_URL: 'https://oauth-dev.fueltech.cloud',
    COGNITO_CLIENT_ID: 'bm14iddbqdhssdlg2q7vlqesh',
    REQUIRE_APPROVAL: true,
    HLS_PLAYBACK: true,
    downloadsBaseUrl: 'https://dev-downloads.ftpilot.com',
}
